import CurrencyDisplay from "@/app/components/currencyDisplay";
import Tooltip from "@/components/design-system/tooltip";
import QuestionMarkIcon from "public/next-public/common/icons/question-mark.svg";
import styles from "./noAdditionalShippingPopover.module.scss";

function NoAdditionalShippingPopover({ vendorOption }: NoAdditionalShippingPopoverProps) {
  const content = (
    <>
      Standard Shipping Cost (<CurrencyDisplay value={vendorOption.standardShipping.toFixed(2)} />) is already taken
      care of - You have an order started with this vendor in your cart, so you will not be charged additional standard
      shipping for this product.
    </>
  );

  return (
    <span className={styles.NoAdditionalShippingPopover}>
      <Tooltip
        tailPlacement="above"
        id={`no-additional-shipping-${vendorOption.vendorProductId}`}
        content={<span className={styles.content}>{content}</span>}
      >
        <button type="button" className={styles.trigger} aria-label="More shipping information">
          <QuestionMarkIcon width={16} height={16} aria-hidden />
        </button>
      </Tooltip>
    </span>
  );
}

type NoAdditionalShippingPopoverProps = {
  vendorOption: VendorOptionState;
};

export default NoAdditionalShippingPopover;
